import { useState } from 'react';
import styled from 'styled-components';
// components
import { Loading, Button } from 'carbon-components-react';
import TileHeader from '../../components/TileHeader/TileHeader';
import ConfirmModal from '../../components/Modal/ConfirmModal';
import { Container, ContentContainer } from '../../components/Wrapper/Wrapper';
// hooks
import useLocations from './useLocationsGrid'
import usePollReport from '../../hooks/usePollReport';
import { triggerReport } from '../../api/studyListApi';
import { toaster } from '../../helpers/toaster';

const Locations = () => {
  const {
    locationsGrid,
    addLocationButton,
    locationSearch,
    locationsLoading,
  } = useLocations()

  const { startPolling, status: reportStatus } = usePollReport({
    onSuccess: () => { toaster('Locations report downloaded successfully', 'success'); },
    onError: () => toaster('Failed to generate report. Please try again.', 'error'),
  });

  const [openReportModal, setOpenReportModal] = useState(false);

  const handleGenerateReport = () => {
    setOpenReportModal(false);
    triggerReport('locations')
      .then(({ task_id }) => {
        toaster('Generating locations report...', 'info');
        startPolling(task_id);
      })
      .catch(() => toaster('Failed to start report generation.', 'error'));
  };

  return (
    <Container>
      <ContentContainer>
        <TileHeader
          title="Locations"
          subtitle=""
          size="lg"
        />
        {
          locationsLoading ?
            <Loading />
            :
            <></>
        }
        <LocationsContent>
          <ActionBar>
            {locationSearch()}
            <ButtonPadding>
              <Button
                kind="secondary"
                onClick={() => setOpenReportModal(true)}
                disabled={reportStatus === 'polling'}
                style={btnStyle}
              >{reportStatus === 'polling' ? 'Generating...' : 'Generate Report'}</Button>
              {addLocationButton()}
            </ButtonPadding>
          </ActionBar>
          {locationsGrid()}
        </LocationsContent>
        <ConfirmModal
          title="Generate Report"
          content="Do you want to generate the report? This may take awhile. Navigating away from this page will stop the report generation."
          open={openReportModal}
          onClose={() => setOpenReportModal(false)}
          onConfirm={handleGenerateReport}
        />
      </ContentContainer>
    </Container>
  );
};

export default Locations;

const LocationsContent = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 22px 24px;
  background-color: #fff;
  border: 1px solid #e7eaf0;
  border-radius: 14px;
  box-shadow: 0 1px 3px rgba(0,0,0,.04);
`

const ActionBar = styled.div`
  width: 100%;
  height: fit-content;
  background-color: #fff;
  margin-bottom: 16px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`

const ButtonPadding = styled.div`
  display: flex;
  gap: 8px;
`

const btnStyle = {
  padding: "11px 18px",
  height: "auto",
  minHeight: "unset",
  borderRadius: "10px",
  fontFamily: "'Plus Jakarta Sans', system-ui, sans-serif",
  fontWeight: 700,
  fontSize: "13.5px",
};
